/** Affiche le nom du menu en infobulle sur les icônes du menu principal, sauf dans le shell 360. */
export const showTooltips = !window.location.href.includes('360');
